// extracted by mini-css-extract-plugin
module.exports = {"pointer":"i_Qo","wrapper":"i_Qp","icon":"i_Qq"};